<div class="flex flex-col items-center justify-center p-24 text-gray-600">
  <span class="no-data-icon text-center">&#10754;</span>
  <span class="whitespace-nowrap">Data unavailable</span>
</div>
